// "לעדכן את מצב הפציעה בפרופיל?" (2026-10-27; navigation since 2026-10-29): the coach's suggestion to update the
// profile's injury state. The chat never writes the profile: the button opens the profile at its health card, where the
// save offers the plan rebuild (product decision — every plan-shaping setting is changed in the profile). "לא עכשיו"
// only closes the card. Graphite: card + line border, lime CTA.
import React, { useState } from 'react';
import { Bandaids } from '@phosphor-icons/react';

const COPY = {
  pain: {
    title: 'לעדכן את מצב הפציעה בפרופיל?',
    body: 'כך המאמן והתכנית יתחשבו בכאב גם בהמשך. העדכון נעשה במסך הפרופיל, ושם אפשר גם לעדכן את התכנית.',
  },
  ok: {
    title: 'לעדכן את מצב הפציעה בפרופיל ל"כשיר"?',
    body: 'כתבת שהכאב חלף. את מצב הפציעה מעדכנים במסך הפרופיל, ושם אפשר גם לעדכן את התכנית.',
  },
};

export default function InjuryStateOffer({ offer, onOpenProfile }) {
  const copy = COPY[offer && offer.suggest];
  const [dismissed, setDismissed] = useState(false);
  if (!copy || dismissed) return null;
  return (
    <div className="w-full max-w-[92%] rounded-[16px] bg-surface border border-border p-4" data-testid="injury-offer"
         data-suggest={offer.suggest} role="group" aria-label={copy.title}>
      <div className="flex items-start gap-2">
        <Bandaids size={20} weight="bold" className="text-text-body shrink-0 mt-0.5" aria-hidden="true" />
        <div className="min-w-0">
          <p className="m-0 text-[15px] font-bold text-text leading-snug">{copy.title}</p>
          <p className="mt-1 mb-0 text-[13px] text-text-muted leading-relaxed">{copy.body}</p>
        </div>
      </div>
      <div className="mt-3 flex gap-2">
        {onOpenProfile && (
          <button type="button" onClick={() => onOpenProfile()} data-testid="injury-offer-open-profile"
                  className="flex-1 min-h-[48px] px-3 rounded-full btn-primary text-[14px]">
            מעבר לפרופיל
          </button>
        )}
        <button type="button" onClick={() => setDismissed(true)} data-testid="injury-offer-dismiss"
                className="min-h-[48px] px-4 rounded-full border border-border text-text-body text-[14px] font-semibold">
          לא עכשיו
        </button>
      </div>
    </div>
  );
}
